module.exports = __webpack_public_path__ + "img/Service-ability-04.23c4e689.png";